import { Loggable } from '@rbi-ctg/frontend';

export const UNKNOWN_ERROR_MESSAGE = 'Unknown application error. Unable to parse error message.';

interface Context {
  [x: string]: Loggable | Loggable[];
}

export interface IDatadogLogger {
  context?: Context;
  message: Loggable;
  status: LogLevel;
}
export enum LogLevel {
  trace = 10,
  debug = 20,
  info = 30,
  warn = 40,
  error = 50,
  fatal = 60,
}
